var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 1.75H11.3125V1.125C11.3125 1.05625 11.2563 1 11.1875 1H10.3125C10.2438 1 10.1875 1.05625 10.1875 1.125V1.75H7.8125V1.125C7.8125 1.05625 7.75625 1 7.6875 1H6.8125C6.74375 1 6.6875 1.05625 6.6875 1.125V1.75H5C4.72344 1.75 4.5 1.97344 4.5 2.25V4.125H3C2.72344 4.125 2.5 4.34844 2.5 4.625V14.5C2.5 14.7766 2.72344 15 3 15H11C11.2766 15 11.5 14.7766 11.5 14.5V13H13C13.2766 13 13.5 12.7766 13.5 12.5V2.25C13.5 1.97344 13.2766 1.75 13 1.75ZM10.375 7.59375H8.03125V5.25H8.03438L10.375 7.59062V7.59375ZM12.375 11.875H11.5V7.125L8.5 4.125H5.625V2.875H6.6875V3.375C6.6875 3.44375 6.74375 3.5 6.8125 3.5H7.6875C7.75625 3.5 7.8125 3.44375 7.8125 3.375V2.875H10.1875V3.375C10.1875 3.44375 10.2438 3.5 10.3125 3.5H11.1875C11.2563 3.5 11.3125 3.44375 11.3125 3.375V2.875H12.375V11.875Z",
    fill: "#D4E8FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.66f3e71cb85f2bbe758d6a36b3848605.svg";
export { ForwardRef as ReactComponent };